import { AccountInfo } from "@azure/msal-browser";
import { deleteData, postData } from "./base";


export async function deleteDataApi (endpoint: string,
    accounts: AccountInfo[]) {
    const res = await deleteData(endpoint, accounts);
    return res;
}

export async function deleteCompanyDetail (data: object,
    accounts: AccountInfo[]) {
    const res = await postData('DeleteCompanyDetail', data, accounts);
    return res;
}